/**
 * Break-glass: reveals the insurance fields when the toggle goes on.
 *
 * It animates `max-height` rather than `height: auto`, which browsers refuse to
 * transition — an unbounded cap stands in for the content's real height. That
 * trick is the whole component and there is no ui-core primitive for it.
 */

import type { ReactNode } from "react";

interface BookShipmentInsuranceRevealProps {
  open: boolean;
  children: ReactNode;
}

export function BookShipmentInsuranceReveal({
  open,
  children,
}: BookShipmentInsuranceRevealProps) {
  return (
    <div
      className={`overflow-hidden transition-[max-height,opacity] duration-500 ease-[ease] ${
        open ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"
      }`}
    >
      {/* The gap above the revealed fields lives inside the clipped box so it
          collapses with them. As the parent's flex gap it stayed behind when
          the toggle was off, leaving the panel with far more room under the
          switch than above it. */}
      <div className="pt-6">{children}</div>
    </div>
  );
}
